"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCouponUpdateInputSchema = exports.APosCouponCreateInputSchema = exports.APosCouponSchema = exports.APosCouponStatusSchema = exports.APosCouponTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosCouponTypeSchema = zod_1.z.enum(['single_use', 'multi_use', 'unlimited']);
exports.APosCouponStatusSchema = zod_1.z.enum(['active', 'inactive', 'expired', 'depleted']);
exports.APosCouponSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    couponId: id_schema_1.EntityIdSchema,
    code: zod_1.z.string().min(3).max(30).regex(/^[A-Z0-9\-]+$/),
    promotionId: id_schema_1.EntityIdSchema,
    couponType: exports.APosCouponTypeSchema,
    maxUses: zod_1.z.number().int().positive().optional(),
    currentUses: zod_1.z.number().int().nonnegative().default(0),
    validFrom: zod_1.z.number().optional(),
    validUntil: zod_1.z.number().optional(),
    status: exports.APosCouponStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCouponCreateInputSchema = zod_1.z.object({
    code: zod_1.z.string().min(3).max(30).regex(/^[A-Z0-9\-]+$/),
    promotionId: id_schema_1.EntityIdSchema,
    couponType: exports.APosCouponTypeSchema,
    maxUses: zod_1.z.number().int().positive().optional(),
    validFrom: zod_1.z.number().optional(),
    validUntil: zod_1.z.number().optional(),
});
exports.APosCouponUpdateInputSchema = zod_1.z.object({
    maxUses: zod_1.z.number().int().positive().optional(),
    validFrom: zod_1.z.number().optional(),
    validUntil: zod_1.z.number().optional(),
    status: exports.APosCouponStatusSchema.optional(),
});
//# sourceMappingURL=coupon.schema.js.map